export default "__VITE_ASSET__DmlQKRPL__"